export default __webpack_public_path__ + "static/media/chat-notification.616f1cec.mp3";